module.exports = __webpack_public_path__ + "img/instagram.46ce74c2.svg";